// Libraries
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
// Components
import Icon from 'HTKit/Icon';
import Button, { THEMES as BUTTON_THEMES } from 'HTKit/Forms/Button';
import InputField from 'HTKit/Forms/InputField';
// Data && Utils
import { prevented } from 'src/utils/event';
import { FORM_VALIDATION_RULES, PAGE_NAME } from './constants';
// Styles
import styles from './styles.scss';

const ToolTip = ({ close }) => (
  <div className={cn(styles.toolTip, 'caption')} onClick={close}>
    Your order number can be found on any of the HelloTech emails you would have received after placing your order.
  </div>
);

const Form = ({ pageErrors, submitForm, validateForm }) => {
  const initialForm = { orderId: '', lastName: '' };
  const [form, setForm] = useState(initialForm);
  const [showToolTip, setShowToolTip] = useState(false);

  const toggleToolTip = () => setShowToolTip(!showToolTip);
  const captureInput = (event) => setForm({ ...form, [event.target.name]: event.target.value });

  const handleSubmission = () => {
    validateForm(
      { form, name: PAGE_NAME, rules: FORM_VALIDATION_RULES },
      {
        onSuccess: () => submitForm({ form }),
      },
    );
  };

  return (
    <form onSubmit={prevented(handleSubmission)}>
      <div className={cn(styles.formInputContainer, 'form-item')}>
        {showToolTip && <ToolTip close={toggleToolTip} />}
        <Icon name="v2-info-icon-default" onClick={toggleToolTip} className={styles.infoIcon} />
        <InputField
          error={pageErrors.orderId}
          label="Order Number"
          name="orderId"
          onChange={captureInput}
          placeholder="Enter Order Number"
          value={form.orderId}
        />
      </div>
      <div className={cn(styles.formInputContainer, 'form-item')}>
        <InputField
          error={pageErrors.lastName}
          label="Last Name"
          name="lastName"
          onChange={captureInput}
          placeholder="Enter Last Name"
          value={form.lastName}
        />
      </div>
      <Button
        className={styles.submitButton}
        onClick={prevented(handleSubmission)}
        theme={BUTTON_THEMES.V2PRIMARY}
      >
        Continue
      </Button>
    </form>
  );
};

Form.propTypes = {
  pageErrors: PropTypes.object,
  submitForm: PropTypes.func.isRequired,
  validateForm: PropTypes.func.isRequired,
};

Form.defaultProps = {
  pageErrors: {},
  submitForm: () => {},
  validateForm: () => {},
};

ToolTip.propTypes = { close: PropTypes.function };
ToolTip.defaultProps = { close: () => {} };

export default React.memo(Form);
